<div class="toolbar" role="banner">
  <img alt="Angular Logo" src="../assets/images/header-logo.png" />
</div>
<div role="main">
  <img alt="Angular Logo" class="middle-image" src="../assets/images/background.png" />
</div>
<div class="card-container container-fluid" role="main">
  <div class="content" role="main">
    <div class="row">
      <div class="col-lg-4">
        <div class="image-field">
          <img src="../assets/images/jpmc.png" />
        </div>
      </div>

      <div class="col-lg-8">
        <section class="example-section" style="line-height: -0.5">
          <h4 class="example-section" style="font-size: 17px">
            Payment Details <br />
            <i class="specific">(For multiple contract payments, please select Mobile Number option)</i>
          </h4>

          <div class="row">
            <div class="col-lg-4 border-right">
              <h6>Select any one</h6>
              <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group">
                <mat-radio-button value="1" aria-checked="true" (change)="onOptionChange('ContractNumber')">Contract
                  Number</mat-radio-button>
                <mat-radio-button value="2" aria-checked="false" (change)="onOptionChange('VehicleNumber')">Registered
                  Vehicle Number</mat-radio-button>
                <mat-radio-button value="3" aria-checked="false" (change)="onOptionChange('MobileNumber')">Registered
                  Mobile Number</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-lg-8">
              <h6>Enter Details</h6>

              <!-- Contract Number Field -->
              <div>
                <mat-form-field appearance="outline" *ngIf="showInputField">
                  <mat-label>Contract Number</mat-label>
                  <input type="text" id="customInput" matInput [formControl]="conName"
                    placeholder="Enter Contract Number" (input)="sanitizeNumericInput($event, 'conName')" minlength="8"
                    maxlength="8" (ngModelChange)="handleInputChange('ContractNumber', $event)"
                    (keydown.backspace)="resetForm()" required />
                  <mat-error *ngIf="conName.invalid && (conName.dirty || conName.touched)">
                    <div *ngIf="conName.errors?.required" class="upload-error">
                      Contract Number is required
                    </div>
                    <div *ngIf="conName.errors?.pattern || conName.errors?.minlength || conName.errors?.maxlength"
                      class="upload-error">
                      Please enter exactly 8 digits
                    </div>
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Vehicle Number Field -->
              <div>
                <mat-form-field appearance="outline" *ngIf="showInputField1">
                  <mat-label>Registered Vehicle Number</mat-label>
                  <input type="text" matInput [(ngModel)]="vehicleNumber"
                    (ngModelChange)="validateVehicleNumber($event)" (keypress)="allowAlphanumericOnly($event)"
                    placeholder="Enter Registered Vehicle Number" maxlength="15" autocomplete="off"
                    #vehicleInput="ngModel" (keydown.backspace)="resetForm()" required pattern="^[A-Z0-9]{7,15}$" />


                  <mat-error class="upload-error"
                    *ngIf="vehicleInput.invalid && (vehicleInput.dirty || vehicleInput.touched)">
                    <span *ngIf="vehicleInput.errors?.required">Vehicle number is required</span>
                    <span *ngIf="vehicleInput.errors?.pattern">
                      Vehicle No must between (7-15 alphanumeric characters)
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Mobile Number and Contract Selection -->
              <div>
                <form [formGroup]="form">
                  <mat-form-field appearance="outline" *ngIf="showInputField2">
                    <mat-label>Registered Mobile Number</mat-label>
                    <input type="text" minlength="10" maxlength="10" id="customInput2" matInput [formControl]="regMob"
                      placeholder="Enter Registered Mobile Number" (ngModelChange)="
                        handleInputChange('MobileNumber', $event)" (keydown.backspace)="resetForm()"
                      (ngModelChange)="fetchContractNobyMobileNo()" (input)="handleNumericInput($event)"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" *ngIf="showInputField2">
                    <mat-label>Select Contract Number</mat-label>
                    <mat-select formControlName="selectedContractNo">
                      <mat-option *ngFor="let contract of contractNumbers" [value]="contract">{{ contract
                        }}</mat-option>
                    </mat-select>
                    <mat-error class="upload-error" *ngIf="errorFlag">{{ errorMessage }}</mat-error>
                  </mat-form-field>
                </form>
              </div>

              <!-- Submit Button -->
              <button mat-raised-button color="primary" style="display: flex; margin-top: 15px"
                (click)="fetchByCustomerDetails()" [disabled]="!isFormValid">
                Submit
              </button>
            </div>
          </div>
        </section>
        <section class="example-section border-section" *ngIf="customerDetailsFetched">
          <mat-grid-list cols="2" rowHeight="80px" gutterSize="15px">
            <mat-form-field appearance="outline">
              <mat-label>Contract Number</mat-label>
              <input type="text" matInput [formControl]="conName" placeholder="Enter Contract Number" readonly="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Registered Vehicle Number</mat-label>
              <input type="text" matInput [formControl]="vehnum" placeholder="Enter Registered Vehicle Number"
                readonly="true" />
            </mat-form-field>
          </mat-grid-list>

          <mat-grid-list cols="2" rowHeight="80px" gutterSize="15px">
            <mat-form-field appearance="outline">
              <mat-label>Registered Mobile Number</mat-label>
              <input type="text" matInput [formControl]="mobile" placeholder="Enter Mobile Number" readonly="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Borrower Name</mat-label>
              <input type="text" matInput [formControl]="borname" placeholder="Enter Borrower Name" readonly="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Email ID</mat-label>
              <input type="text" matInput [formControl]="emailFormControl" placeholder="Enter Email ID"
                readonly="true" />
            </mat-form-field>
          </mat-grid-list>

          <form [formGroup]="form1">
            <mat-grid-list cols="2" rowHeight="100px" gutterSize="15px">
              <mat-form-field appearance="outline">
                <mat-label>Payment Received From<span> *</span></mat-label>
                <mat-select formControlName="paymentInfo" readonly>
                  <mat-option value="Self">Self</mat-option>
                  <mat-option value="Family Member">Family Member</mat-option>
                  <mat-option value="Third Party">Third Party</mat-option>
                </mat-select>
                <mat-error *ngIf="form1.controls['paymentInfo'].hasError('required')">Payment Received From is
                  required.</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" *ngIf="
                  ['Family Member', 'Third Party'].includes(
                    form1.get('paymentInfo')?.value
                  )
                ">
                <mat-label>Name </mat-label>
                <input type="text" matInput formControlName="name" placeholder="Name" (keypress)="onKeypress($event)"
                  required maxlength="30" />
                <mat-error *ngIf="form1.controls['name'].hasError('required')">
                  Name is required.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Payee Mobile Number</mat-label>
                <input type="text" matInput formControlName="payeeMobileNo" placeholder="Enter Payee Mobile No"
                  minlength="10" maxlength="10" required (input)="handleNumericInput($event)"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                <mat-error *ngIf="form1.controls['payeeMobileNo'].hasError('required')">Payee Mobile No are
                  required.</mat-error>
                <mat-error *ngIf="form1.controls['payeeMobileNo'].hasError('pattern')">Invalid Payee Mobile
                  No</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Actual Amount</mat-label>
                <input type="text" matInput formControlName="invoiceAmount" placeholder="INR" readonly />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Amount Payable </mat-label>
                <input type="text" matInput formControlName="amountPayable" placeholder="INR" required step="0.01"
                  min="0" (keypress)="numericOnly($event)" (blur)="validateAmountPayable()" />
                <mat-error *ngIf="form1.controls['amountPayable'].hasError('required')">Amount Payable are
                  required.</mat-error>
                <mat-error *ngIf="form1.controls['amountPayable'].hasError('max')">
                  Amount cannot exceed {{ form1.get("invoiceAmount")?.value }}
                </mat-error>
              </mat-form-field>
            </mat-grid-list>
          </form>

          <mat-grid-list cols="2" rowHeight="90px" gutterSize="15px" style="margin-top: 60px">
            <section class="example-section">
              <mat-checkbox id="checkbox" [(ngModel)]="checkboxValue" [ngModelOptions]="{ standalone: true }">
                I accept below
                <a href="#" (click)="openTermsAndConditionsPopup($event)">Terms & Conditions</a>
              </mat-checkbox>
              <mat-error *ngIf="formSubmitted && !checkboxValue">You must agree to the Terms and Conditions</mat-error>
              <br />
              <button mat-raised-button color="primary" (click)="submitBenzDetails()">
                PAY NOW
              </button>
            </section>
          </mat-grid-list>
        </section>
      </div>

      <div>
        <form target="_top" #txnForm [formGroup]="tranxnForm" method="POST" action="{{ isgPay_url }}">
          <input type="hidden" [value]="EncDataField" name="EncData" formControlName="EncData" />
          <input type="hidden" [value]="MerchantIdField" name="MerchantId" formControlName="MerchantId" />
          <input type="hidden" [value]="BankIdField" name="BankId" formControlName="BankId" />
          <input type="hidden" [value]="TerminalIdField" name="TerminalId" formControlName="TerminalId" />
          <input type="hidden" [value]="VersionField" name="Version" formControlName="Version" />
          <input type="hidden" [value]="TransactionId" name="OrderId" formControlName="TransactionId" />
          <input type="hidden" [value]="emailId" name="Email" formControlName="emailId" />
          <input type="hidden" [value]="mobileNo" name="Phone" formControlName="mobileNo" />
          <input type="hidden" [value]="firstName" name="FirstName" formControlName="firstName" />
          <input type="hidden" [value]="lastName" name="LastName" formControlName="lastName" />
        </form>
      </div>
    </div>
  </div>
</div>

<div class="footer" role="banner">
  <mat-grid-list cols="2" rowHeight="50px" gutterSize="15px">
    <section class="example-section-footer">
      <img alt="Angular Logo" src="../assets/images/logo.png" class="img-center" />
    </section>
  </mat-grid-list>

  <mat-grid-list cols="2" rowHeight="50px" gutterSize="15px">
    <section class="example-section-footer top-space">
      <img alt="Angular Logo" src="../assets/images/UPI.svg" class="img-logos" />
      <img alt="Angular Logo" src="../assets/images/RuPay.svg" class="img-logos" />
      <img alt="Angular Logo" src="../assets/images/VISA.svg" class="img-logos" />
      <img alt="Angular Logo" src="../assets/images/MasterCard.svg" class="img-logos" />
    </section>
  </mat-grid-list>
</div>